import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    errorMessage: {
      padding: theme.spacing(0, 2),
    },
  };
};
